/* @ngInject */
export const logProvider = (ENVIRONMENT_CONSTANTS, $logProvider: ng.ILogProvider) => {
	$logProvider.debugEnabled(ENVIRONMENT_CONSTANTS.APP_ENVIRONMENT !== ENVIRONMENT_CONSTANTS.PROD);
};
